/* istanbul ignore file */
export const MAP = `__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const MARKER = `__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const ANCHOR = `__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const MARKER_CLUSTERER = `__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const POLYLINE = `__SECRET_POLYLINE_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const POLYGON = `__SECRET_POLYGON_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const MARKER_WITH_LABEL = `__SECRET_MARKER_WITH_LABEL_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
export const INFO_BOX = `__SECRET_INFO_BOX_WITH_LABEL_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`
